"use strict";

import {gh} from '../general/general-helpers';

(function( $ ) {
	// Only for single-video post type
	if ( document.body.classList.contains( 'single-video' ) ) {

		/* Time codes slider
		-------------------------------------------------------------------*/
		$('.time-codes-slider').owlCarousel( {
			loop:              false,
			margin:            20,
			autoWidth:         true,
			nav:               true,
			dots:              false,
			mouseDrag:         false,
			// items: 3,
			navContainerClass: 'owl-nav position-absolute w-100 mt-0 d-flex justify-content-between',
			navText:    ['<svg width="31" height="28" class="svg-icon z-index-1"><use xlink:href="#sv-icons__big-arrow"/></svg>', '<svg width="31" height="28" class="svg-icon z-index-1"><use xlink:href="#sv-icons__big-arrow"/></svg>'],
			responsive: {
				0: {
					slideBy: 1,
				},
				768: {
					slideBy: gh.isMobileDevice ? 1 : 1,
				},
				1200: {
					slideBy: 3,
				},
			},
		} );
	} // IF this page
})( jQuery );

